<template>
  <div>
    <Nav current="公司后台"></Nav>
    <div class="content">
      <div class="title">编辑系统</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name"><span class="xing">*</span> 系统名称</span>
          <input type="text" v-model="name" />
        </div>
        <div class="form_item">
          <span class="item_name"><span class="xing">*</span>系统域名</span>
          <input type="text" v-model="url" /><span class=""
            >例:https://xxx.com/a/a/</span
          >
        </div>
        <div class="form_item">
          <span class="item_name indent">是否设为默认系统</span>
          <div class="radio">
            <template>
              <el-radio v-model="defaultSystem" label="false">否</el-radio>
              <el-radio v-model="defaultSystem" label="true">是</el-radio>
            </template>
          </div>
        </div>
        <!-- <div class="form_item">
          <span class="item_name indent">是否设为主库</span>
          <div class="radio">
            <template>
              <el-radio v-model="ismaster" label="false">否</el-radio>
              <el-radio v-model="ismaster" label="true">是</el-radio>
            </template>
          </div>
        </div> -->
      </div>
    </div>
    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="updateSystem"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      name: "",
      url: "",
      id:'',
      defaultSystem: 'false',
      // ismaster: 'false',
    };
  },
  created() {
    this.getSystemList();
  },
  mounted() {},
  methods: {
    getSystemList() {
      let _this = this;
      //  console.log(_this.$route.query.id)
      let sysId = _this.$route.query.id
      http.get(apiData.systemShow, true, { id:sysId }, (res) => {
        if (res.data.code == 200) {
          //  console.log(res.data)
          _this.name = res.data.data.name;
          _this.url = res.data.data.url;
          _this.id = res.data.data.id;
          _this.defaultSystem = JSON.stringify(res.data.data.defaultSystem); //把类型转为字符串类型  默认选中
          // _this.ismaster = JSON.stringify(res.data.data.ismaster); //把类型转为字符串类型  默认选中
        } else {
          _this.$message.error("加载失败");
        }
      });
    },
    updateSystem() {
      var _this = this;
      // console.log(this.dataList,1111)
      let params = {
        name: _this.name,
        url: _this.url,
        id:_this.id,
        defaultSystem: _this.defaultSystem,
        // ismaster: _this.ismaster,
      };
      // apiData.updateSystem 这是空的
      console.log(params)
      // if (_this.name != "" && _this.url != "") {
        http.put(apiData.systemUpdate, true, params, function (res) {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          _this.$message.success("添加成功");
          _this.$router.go(-1);
        } else {
          _this.$message.success("添加失败");
        }
      });
      // } else {
      //   _this.$message.success("值不可以为空");
      // }

      // console.log(params,1111)
     
    },
    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;
        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.indent {
  font-size: 12px;
}
.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}

.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  border: 1px solid #55c4b8;

  color: #fff;
}
</style>
